<template>
  <v-container grid-list-md fluid>
    <v-layout row wrap>
      <v-flex md12>
        <data-table ref="tableBitacora" />
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import DataTable from "@/views/bitacoras/bitacora/DataTable";

export default {
  name: "BitacoraModule"
  , components: { DataTable }
  , data() {
    return {
      view: { title: this.$t("view.bitacoras.bitacora.title") }
      , check: true
    };
  }
  , head: {
    title: function () {
      return {
        inner: this.view.title
        , separator: "|"
        , complement: this.$t("view.commons.system")
      };
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/bitacoras/bitacora/Bitacora.vue